// extracted by mini-css-extract-plugin
export var paginationCurrent = "index-module--pagination-current--df339";
export var thumbsSwiper = "index-module--thumbs-swiper--c7847";